module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/homeofthebrave.a6afee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/homeofthebrave.jpg
// module id = zmjd
// module chunks = 0